module.exports = __webpack_public_path__ + "img/lung.a025f78b.png";